import {retainWan} from "@/plugins/helper";

export const TYPE_MAP = {
  1: {
    label: '商品数',
    formatFn: value => retainWan(value,false,2,'--')
  },
  2: {
    label: '销量',
    formatFn: value => retainWan(value,false,2,'--')
  },
  3: {
    label: '销售额',
    formatFn: value =>` ¥${retainWan(value,false,2,'--')}`
  },
}



export const COLOR_LIST = [
  '#2877FF',
  '#54AAFF',
  '#7DC2FF',
  '#A6D8FF',
  '#CFECFF'
]
export const OTHER_COLOR =   '#FFBA32'


export const makeButtonList = (list = []) => {
  return list?.map(value => ({
    label: TYPE_MAP[value].label,
    value
  }))
}


export const parseColor = (name,index) => {
  if(name === '其他') return OTHER_COLOR
  else return COLOR_LIST[(index % COLOR_LIST.length)]
}
